import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'smartCurrency',
})
export class SmartCurrencyPipe implements PipeTransform {
  private currencyPipe = new CurrencyPipe('es-ES');

  transform(
    value: number | null | undefined,
    currencyCode = 'EUR',
    display: 'code' | 'symbol' | 'symbol-narrow' | string = 'symbol',
  ): string | null {
    if (value == null) {
      return null;
    }

    const hasDecimals = value % 1 !== 0;
    const digitsInfo = hasDecimals ? '1.2-2' : '1.0-0';

    const result = this.currencyPipe.transform(value, currencyCode, display, digitsInfo);
    // Eliminar el espacio entre el número y el símbolo €
    return result?.replace(/\s€/, '€') ?? null;
  }
}
